import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  invalidTrailingComma2uwwnmbqspks2 as invalidTrailingComma,
  decodingExceptionOf2yxeurf3w1vi4 as decodingExceptionOf,
} from './JsonExceptions.mjs';
import {
  JsonObjectee06ihoeeiqj as JsonObject,
  JsonArray2urf8ey7u44sd as JsonArray,
  JsonNull_getInstance1i1hv1sbjynto as JsonNull_getInstance,
  JsonLiteral1u57id0qmqut7 as JsonLiteral,
} from '../JsonElement.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  DeepRecursiveFunction3r49v8igsve1g as DeepRecursiveFunction,
  invoke246lvi6tzooz1 as invoke,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/DeepRecursive.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { tokenDescription3r6eqmtoxe76u as tokenDescription } from './AbstractJsonLexer.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function readObject($this) {
  // Inline function 'kotlinx.serialization.json.internal.JsonTreeReader.readObjectImpl' call
  var lastToken = $this.i2v_1.n2v(6);
  if ($this.i2v_1.o2v() === 4) {
    $this.i2v_1.f2u('Unexpected leading comma');
  }
  // Inline function 'kotlin.collections.linkedMapOf' call
  var result = LinkedHashMap().fc();
  $l$loop: while ($this.i2v_1.p2v()) {
    var key = $this.j2v_1 ? $this.i2v_1.r2v() : $this.i2v_1.q2v();
    $this.i2v_1.n2v(5);
    var element = $this.s2v();
    // Inline function 'kotlin.collections.set' call
    result.b5(key, element);
    lastToken = $this.i2v_1.t2v();
    var tmp0_subject = lastToken;
    if (tmp0_subject !== 4)
      if (tmp0_subject === 7)
        break $l$loop;
      else {
        $this.i2v_1.f2u('Expected end of the object or comma');
      }
  }
  if (lastToken === 6) {
    $this.i2v_1.n2v(7);
  } else if (lastToken === 4) {
    if (!$this.k2v_1) {
      invalidTrailingComma($this.i2v_1);
    }
    $this.i2v_1.n2v(7);
  }
  return new (JsonObject())(result);
}
function *readObject_0($this, $receiver, $completion) {
  // Inline function 'kotlinx.serialization.json.internal.JsonTreeReader.readObjectImpl' call
  var lastToken = $this.i2v_1.n2v(6);
  if ($this.i2v_1.o2v() === 4) {
    $this.i2v_1.f2u('Unexpected leading comma');
  }
  // Inline function 'kotlin.collections.linkedMapOf' call
  var result = LinkedHashMap().fc();
  $l$loop: while ($this.i2v_1.p2v()) {
    var key = $this.j2v_1 ? $this.i2v_1.r2v() : $this.i2v_1.q2v();
    $this.i2v_1.n2v(5);
    var element = yield* $receiver.st(Unit_instance, $completion);
    // Inline function 'kotlin.collections.set' call
    result.b5(key, element);
    lastToken = $this.i2v_1.t2v();
    var tmp0_subject = lastToken;
    if (tmp0_subject !== 4)
      if (tmp0_subject === 7)
        break $l$loop;
      else {
        $this.i2v_1.f2u('Expected end of the object or comma');
      }
  }
  if (lastToken === 6) {
    $this.i2v_1.n2v(7);
  } else if (lastToken === 4) {
    if (!$this.k2v_1) {
      invalidTrailingComma($this.i2v_1);
    }
    $this.i2v_1.n2v(7);
  }
  return new (JsonObject())(result);
}
function readArray($this) {
  var lastToken = $this.i2v_1.t2v();
  if ($this.i2v_1.o2v() === 4) {
    $this.i2v_1.f2u('Unexpected leading comma');
  }
  // Inline function 'kotlin.collections.arrayListOf' call
  var result = ArrayList().p2();
  while ($this.i2v_1.p2v()) {
    var element = $this.s2v();
    result.j2(element);
    lastToken = $this.i2v_1.t2v();
    if (!(lastToken === 4)) {
      var tmp0 = $this.i2v_1;
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.require' call
      var condition = lastToken === 9;
      var position = tmp0.n2o_1;
      if (!condition) {
        var tmp$ret$2 = 'Expected end of the array or comma';
        tmp0.f2u(tmp$ret$2, position);
      }
    }
  }
  if (lastToken === 8) {
    $this.i2v_1.n2v(9);
  } else if (lastToken === 4) {
    if (!$this.k2v_1) {
      invalidTrailingComma($this.i2v_1, 'array');
    }
    $this.i2v_1.n2v(9);
  }
  return new (JsonArray())(result);
}
function readValue($this, isString) {
  var tmp;
  if ($this.j2v_1 || !isString) {
    tmp = $this.i2v_1.r2v();
  } else {
    tmp = $this.i2v_1.q2v();
  }
  var string = tmp;
  if (!isString && string === 'null')
    return JsonNull_getInstance();
  return new (JsonLiteral())(string, isString);
}
function readDeepRecursive($this) {
  return invoke(new (DeepRecursiveFunction())(JsonTreeReader$readDeepRecursive$slambda($this)), Unit_instance);
}
function JsonTreeReader$readDeepRecursive$slambda(this$0) {
  return constructCallableReference(($this$DeepRecursiveFunction, it, $completion) => orPromise($completion, function *($completion) {
    var tmp0_subject = this$0.i2v_1.o2v();
    var tmp;
    if (tmp0_subject === 1) {
      tmp = readValue(this$0, true);
    } else if (tmp0_subject === 0) {
      tmp = readValue(this$0, false);
    } else if (tmp0_subject === 6) {
      // Inline function 'kotlinx.serialization.json.internal.JsonTreeReader.withDepthControl' call
      var this_0 = this$0;
      this_0.m2v_1 = this_0.m2v_1 + 1 | 0;
      if (this_0.m2v_1 >= this_0.l2v_1) {
        jsonTooNested(this_0.l2v_1);
      }
      var result = yield* /*#__NOINLINE__*/readObject_0(this$0, $this$DeepRecursiveFunction, $completion);
      this_0.m2v_1 = this_0.m2v_1 - 1 | 0;
      tmp = result;
    } else if (tmp0_subject === 8) {
      // Inline function 'kotlinx.serialization.json.internal.JsonTreeReader.withDepthControl' call
      var this_1 = this$0;
      this_1.m2v_1 = this_1.m2v_1 + 1 | 0;
      if (this_1.m2v_1 >= this_1.l2v_1) {
        jsonTooNested(this_1.l2v_1);
      }
      var result_0 = readArray(this$0);
      this_1.m2v_1 = this_1.m2v_1 - 1 | 0;
      tmp = result_0;
    } else {
      this$0.i2v_1.f2u("Can't begin reading element, unexpected token");
    }
    return tmp;
  }), 2);
}
var JsonTreeReaderClass;
function JsonTreeReader() {
  if (JsonTreeReaderClass === VOID) {
    class $ {
      constructor(configuration, lexer) {
        this.i2v_1 = lexer;
        this.j2v_1 = configuration.p2p_1;
        this.k2v_1 = configuration.b2q_1;
        this.l2v_1 = configuration.f2q_1;
        this.m2v_1 = this.i2v_1.o2o_1.o2u_1;
      }
      s2v() {
        var token = this.i2v_1.o2v();
        var tmp;
        if (token === 1) {
          tmp = readValue(this, true);
        } else if (token === 0) {
          tmp = readValue(this, false);
        } else if (token === 6) {
          this.m2v_1 = this.m2v_1 + 1 | 0;
          if (this.m2v_1 >= this.l2v_1) {
            jsonTooNested(this.l2v_1);
          }
          var result;
          if (this.m2v_1 === 200) {
            this.m2v_1 = this.m2v_1 - 1 | 0;
            result = readDeepRecursive(this);
          } else {
            result = readObject(this);
            this.m2v_1 = this.m2v_1 - 1 | 0;
          }
          tmp = result;
        } else if (token === 8) {
          // Inline function 'kotlinx.serialization.json.internal.JsonTreeReader.withDepthControl' call
          this.m2v_1 = this.m2v_1 + 1 | 0;
          if (this.m2v_1 >= this.l2v_1) {
            jsonTooNested(this.l2v_1);
          }
          var result_0 = readArray(this);
          this.m2v_1 = this.m2v_1 - 1 | 0;
          tmp = result_0;
        } else {
          this.i2v_1.f2u('Cannot read Json element because of unexpected ' + tokenDescription(token));
        }
        return tmp;
      }
    }
    initMetadataForClass($, 'JsonTreeReader', VOID, VOID, VOID, [1]);
    JsonTreeReaderClass = $;
  }
  return JsonTreeReaderClass;
}
function jsonTooNested(maxStackDepth) {
  throw decodingExceptionOf('Json input is too nested and may be impossible to parse without stack overflow.', 'Current nesting limit is ' + maxStackDepth + ". To adjust it, use 'maxNestingDepth' in 'Json {}' builder.");
}
//region block: exports
export {
  JsonTreeReader as JsonTreeReader1ycreu77eikqj,
  jsonTooNested as jsonTooNested1sdswo7rhfnql,
};
//endregion

//# sourceMappingURL=JsonTreeReader.mjs.map
